export const SUPER_ADMIN_AGENCY_ID = "superYxadminagency_id";

export const SUPER_ADMIN_AGENCY_INFO = {
  address: "",
  agenct_config: {
    allow: true,
    plugins: [],
    agent_limit: 10000,
    PluginOn: false,
  },
  agency_id: SUPER_ADMIN_AGENCY_ID,
  agentBuilder: null,
  apps: ["AI Social App"],
  assistant_id: "asst_FPOU0HcPwzIwKDC2UrmH1IAz",
  assistants: ["asst_FPOU0HcPwzIwKDC2UrmH1IAz"],
  business_name: "Maybe SuperAdmin",
  chat_username: "Emerson Osmond",
  city: "",
  conversationId: "",
  country: "",
  createdAt: "2025-05-01T08:28:43.138Z",
  default_assistant: "asst_psjAozcGzFSW1L6TPs8oY183",
  email: "emo+super@maybetech.com",
  first_name: "",
  id: "9DITYaucH469so88pN8a",
  isAuto: true,
  isGHLUser: false,
  is_auto: false,
  is_streaming_Api: true,
  is_support: null,
  last_name: "",
  monthly_token_limit: 0,
  monthly_token_usage: 0,
  nango_connected: false,
  number_of_additional_accounts: 0,
  agentBuilderAssistantId: "asst_FPOU0HcPwzIwKDC2UrmH1IAz",
  agentBuilderAccount: {
    id: "9DITYaucH469so88pN8a",
  },
  onboarding: {
    website_url: "www.maybetech.com",
    email: "polly+test@maybetech.com",
    verified: true,
  },
  openAgentBuilder: false,
  phone_number: "",
  planType: "monthly",
  promptlabels_ids: [],
  selected_assistant_id: null,
  state: "",
  time_zone: "Europe/London",
  type: "free",
  updatedAt: "2025-09-11T08:56:54.191Z",
  userId: "ee9ZPyfNsVqyoYj3oxmt",
  userUUID: "675d890df1dc597eff1d53be",
  user_email: "emo kstest@maybetech.com",
  zip_code: "",
  __v: 4,
  _id: "681330bb8349a4a65e6b3391",
};

export const SUPER_ADMIN_AGENCY_CONFIG =
  SUPER_ADMIN_AGENCY_INFO.agenct_config;

export const isSuperAdminAgency = (agencyId) =>
  agencyId === SUPER_ADMIN_AGENCY_ID;
